import { OpenGraph } from './models/openGraph';
import { propel } from './aai/pcomm_router';
import { DataDogLogger } from 'utils/dataDog';
import { CUSTOM_ACTION_NAMES } from 'utils/dataDog/constants';

const generateMetadata = async (
  url: string,
): Promise<{ [k: string]: propel.core.MessageExtension.Information } | null> => {
  try {
    const openGraph: OpenGraph = new OpenGraph();
    await openGraph.load(url);
    const informationExtension = propel.core.MessageExtension.Information.create({
      body: openGraph.description,
      button: propel.core.MessageExtension.Button.create({
        action: propel.core.MessageExtension.Action.create({
          type: 'url',
          url,
        }),
        title: 'Learn More',
      }),
      imageUrl: openGraph.image,
      title: openGraph.title,
    }).toJSON();

    return informationExtension;
  } catch (err) {
    console.error({ message: (err as Error).message });
    return null;
  }
};

const infoCardGeneratorAsync = async (url: string) => {
  DataDogLogger.action(CUSTOM_ACTION_NAMES.INFORMATION_CARD_GENERATOR.INVOKED, {
    url,
  });

  if (!url) return null;

  //TODO: Implement server side cache

  return await generateMetadata(url);
};

export { infoCardGeneratorAsync, generateMetadata };
